import React from 'react';
import Card from '../ui/Card';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { DashboardFilters } from '../../pages/Dashboard';
const allSchemeData = [{
  name: 'Visa',
  baseValue: 35,
  color: '#1A1F71',
  logo: 'https://cdn.magicpatterns.com/uploads/ajjUzt6ZA31HENtrC6smhX/Visa_Logo.png',
  baseCount: 29901,
  baseAmount: 4.4
}, {
  name: 'MasterCard',
  baseValue: 28,
  color: '#F79E1B',
  logo: 'https://cdn.magicpatterns.com/uploads/o4mhjVxt1YvUBCyPQMrSjj/MasterCard_Logo.png',
  baseCount: 23920,
  baseAmount: 3.5
}, {
  name: 'PayPak',
  baseValue: 20,
  color: '#00A651',
  logo: 'https://cdn.magicpatterns.com/uploads/44SLYYjfKQTV8r3NQG1zpK/PayPak_Logo.png',
  baseCount: 17086,
  baseAmount: 2.5
}, {
  name: 'UnionPay',
  baseValue: 10,
  color: '#00A4E4',
  logo: 'https://cdn.magicpatterns.com/uploads/uXMvALLn5Yv7B4FKaBwEcf/UnionPay_Logo.png',
  baseCount: 8543,
  baseAmount: 1.2
}, {
  name: 'RAAST',
  baseValue: 7,
  color: '#DC143C',
  logo: 'https://cdn.magicpatterns.com/uploads/fiLiifU998HKz2FF7RhHiq/RAAST_Logo.png',
  baseCount: 5982,
  baseAmount: 0.9
}];
const timeMultipliers = {
  Today: 1,
  Week: 7,
  MTD: 22,
  YTD: 265
};
const channelMultipliers: Record<string, number> = {
  'All Channels': 1,
  POS: 0.45,
  'E-commerce': 0.35,
  'RAAST QR': 0.2
};
interface TransactionsBySchemeProps {
  filters: DashboardFilters;
}
export const TransactionsByScheme: React.FC<TransactionsBySchemeProps> = ({
  filters
}) => {
  const {
    timeRange,
    scheme,
    channel
  } = filters;
  const timeMult = timeMultipliers[timeRange];
  const channelMult = channelMultipliers[channel];
  const filteredSchemes = scheme === 'All Schemes' ? allSchemeData : allSchemeData.filter(s => s.name === scheme);
  const totalValue = filteredSchemes.reduce((sum, s) => sum + s.baseValue, 0);
  const data = filteredSchemes.map(s => {
    const count = Math.round(s.baseCount * timeMult * channelMult);
    const amount = s.baseAmount * timeMult * channelMult;
    const value = scheme === 'All Schemes' ? s.baseValue : Math.round(s.baseValue / totalValue * 100);
    return {
      name: s.name,
      value,
      color: s.color,
      logo: s.logo,
      count: count.toLocaleString(),
      amount: amount >= 1 ? `PKR ${amount.toFixed(1)}B` : `PKR ${(amount * 1000).toFixed(0)}M`
    };
  });
  return <Card title="Scheme Distribution" className="h-full flex flex-col" data-id="element-310">
      <div className="flex-1 flex flex-col justify-center" data-id="element-311">
        <div className="h-[220px] w-full relative mb-8" data-id="element-312">
          <ResponsiveContainer width="100%" height="100%" data-id="element-313">
            <PieChart data-id="element-314">
              <Pie data={data} cx="50%" cy="50%" innerRadius={75} outerRadius={95} paddingAngle={3} dataKey="value" stroke="none" cornerRadius={4} data-id="element-315">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-316" />)}
              </Pie>
              <Tooltip formatter={(value: number) => [`${value}%`, 'Share']} contentStyle={{
              borderRadius: '12px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
              fontWeight: 600
            }} data-id="element-317" />
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-318">
            <span className="text-xs text-slate-500 dark:text-slate-400 uppercase tracking-wider font-bold mb-1" data-id="element-319">
              Total
            </span>
            <span className="text-3xl font-bold text-slate-900 dark:text-white tracking-tight" data-id="element-320">
              100%
            </span>
          </div>
        </div>

        <div className="space-y-3.5" data-id="element-321">
          {data.map(item => <div key={item.name} className="flex items-center justify-between text-sm p-2 rounded-lg hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors" data-id="element-322">
              <div className="flex items-center space-x-3" data-id="element-323">
                <div className="w-2.5 h-2.5 rounded-full shadow-sm" style={{
              backgroundColor: item.color
            }} data-id="element-324" />
                <div className="w-12 h-8 flex items-center justify-center bg-white rounded-md border border-slate-200 shadow-sm p-1" data-id="element-325">
                  <img src={item.logo} alt={item.name} className="max-h-full max-w-full object-contain" data-id="element-326" />
                </div>
                <span className="font-semibold text-slate-700 dark:text-slate-300" data-id="element-327">
                  {item.name}
                </span>
              </div>
              <div className="flex items-center space-x-5 text-right" data-id="element-328">
                <span className="text-slate-500 dark:text-slate-400 font-medium w-16" data-id="element-329">
                  {item.count}
                </span>
                <span className="font-bold text-slate-900 dark:text-white w-12 bg-slate-100 dark:bg-slate-800 py-1 px-2 rounded-md" data-id="element-330">
                  {item.value}%
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </Card>;
};